import React from 'react';

import { type Nullable } from '@clearverify/types';

import { usePlatformStaffQuery } from 'src/api';

export const usePlatformStaff = (
  platformStaffId: Nullable<string>,
  { skip }: { skip?: boolean } = {},
) => {
  const { data, loading } = usePlatformStaffQuery({
    variables: {
      where: { id: platformStaffId },
    },
    skip: !platformStaffId || skip,
  });

  const platformStaff = React.useMemo(() => {
    return data?.platformStaff;
  }, [data?.platformStaff]);

  return {
    platformStaff,
    loading,
  };
};
